var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Table } from 'template/lib';
Modal.setAppElement('#root');
var ModalPendingCompany = function (props) {
    var history = useHistory();
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), items = _c[0], setItems = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(10), pageSize = _e[0], setPageSize = _e[1];
    var _f = useState(1), totalPages = _f[0], setTotalPages = _f[1];
    var _g = useState(false), hasNext = _g[0], setHasNext = _g[1];
    var config = {
        headers: {
            Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token),
        },
    };
    useEffect(function () {
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
        }
    }, [login, handleLogout, history]);
    useEffect(function () {
        api.get('/companies/validationFinancial', config)
            .then(function (response) {
            var data = response.data;
            var formattedData = Array.isArray(data) ? data : [data];
            setItems(formattedData);
        })
            .catch(function (error) {
            var _a;
            console.log((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            setItems([]);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [props.isOpen, login === null || login === void 0 ? void 0 : login.token, page, pageSize]);
    return (_jsx(Modal, __assign({ isOpen: props.isOpen, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalPendingCompany, overlayClassName: "react-modal-overly", className: "react-modal-content", style: {
            content: {
                width: '100%',
                maxWidth: '900px',
                height: '85vh',
                margin: 'auto',
                padding: '20px',
                overflow: 'hidden',
                borderRadius: '4px'
            }
        } }, { children: _jsxs("div", __assign({ style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            } }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx(AiOutlineClose, { title: "Fechar", className: "cursor-pointer text-sm", onClick: props.handleCloseModalPendingCompany }, void 0)] }), void 0), _jsx("div", __assign({ style: {
                        flex: 1,
                        overflowY: 'auto',
                        marginTop: '10px'
                    } }, { children: _jsx(Table, { setSize: setPageSize, hasNext: hasNext, page: page, setPage: setPage, data: items, loading: loading, totalPAges: totalPages, title: "Clientes com Pend\u00EAncia Financeira", columns: [
                            { label: 'WpsId', key: 'wpsId' },
                            { label: 'Empresa', key: 'wpsName', maxLenghtToShowSeeMore: 120 },
                            { label: 'Documento', key: 'identityNumber' },
                            { label: 'Data de inclusão', key: 'inclusionDateWithTime', center: true },
                        ] }, void 0) }), void 0)] }), void 0) }), void 0));
};
export default ModalPendingCompany;
